export default {
    auth(state) {
        return state.auth;
    },
    rights(state) {
        return state.rights;
    },
    permissions(state) {
        return state.permissions;
    },
    operators(state) {
        return state.operators;
    },

    loading(state) {
        return state.loading;
    }
}
